









import { computed, defineComponent, SetupContext } from '@vue/composition-api';

const Component = defineComponent({
  name: 'NotFoundPage',

  setup(_, { root: { $store } }: SetupContext) {
    const loading = computed(() => $store.getters['uiModule/overlayLoading']);

    return {
      loading,
    };
  },
});

export default Component;
